module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admincentro-escolar-cursos/admincentro-escolar-cursos.component.scss
// module id = ./src/app/admincentro-escolar-cursos/admincentro-escolar-cursos.component.scss
// module chunks = main